import Styles from './ChatTrialEndedMessage.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { usePaywall } from 'components/TimeTriggerPaywall/hooks/usePaywall'

export const ChatTrialEndedMessage = () => {
  const { openPaywall } = usePaywall({ skipRedirect: true })

  return (
    <div className={Styles.container} role="status">
      <Text variant="primary" color="var(--dark-90)">
        Your trial has ended. Upgrade your plan to continue using chat.
      </Text>
      <Button className={Styles.upgradeButton} size="md" variant="primary" onPress={openPaywall}>
        Upgrade
      </Button>
    </div>
  )
}
